module.exports = __webpack_public_path__ + "img/流程2.1c9448a6.png";